import { render, staticRenderFns } from "./CollectionManager.vue?vue&type=template&id=547c7e5c&"
import script from "./CollectionManager.vue?vue&type=script&lang=js&"
export * from "./CollectionManager.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports